<div class="policy-editor" *ngIf="accessPolicy && contractPolicy">
  <div class="policy-grid">
    <section class="policy-section">
      <div class="policy-section__header">
        <span class="policy-section__index">1</span>
        <div>
          <h5>Access Policy</h5>
          <p>Definiert, wer dieses Datenangebot im Catalog überhaupt sehen darf.</p>
        </div>
      </div>

      <div class="policy-choice-grid">
        <button
          type="button"
          class="policy-choice"
          [class.is-active]="accessPolicy.visibility === 'public'"
          (click)="updateVisibility('public')">
          <strong>Federated Catalog</strong>
          <span>Sichtbar für alle potenziellen GU mit passender Katalogsuche.</span>
        </button>
        <button
          type="button"
          class="policy-choice"
          [class.is-active]="accessPolicy.visibility === 'restricted'"
          (click)="updateVisibility('restricted')">
          <strong>Eingeschränkter Catalog</strong>
          <span>Nur für definierte Partnerorganisationen im Control Plane Kontext sichtbar.</span>
        </button>
      </div>

      <div class="policy-controls" *ngIf="accessPolicy.visibility === 'restricted'">
        <div class="policy-controls__field policy-controls__field--full">
          <label for="consumer-orgs">Partnerorganisationen</label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Organisationen auswählen</mat-label>
            <mat-select
              id="consumer-orgs"
              multiple
              [ngModel]="accessPolicy.consumerOrgIds"
              (ngModelChange)="updateConsumerOrgs($event)">
              <div class="policy-org-search">
                <input
                  matInput
                  type="text"
                  placeholder="Organisation suchen…"
                  [(ngModel)]="orgSearchTerm"
                  (keydown)="$event.stopPropagation()"
                  class="policy-org-search__input">
              </div>
              <mat-option *ngFor="let org of filteredOrganisations" [value]="org.id">
                {{ org.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </section>

    <section class="policy-section">
      <div class="policy-section__header">
        <span class="policy-section__index">2</span>
        <div>
          <h5>Contract Policy</h5>
          <p>Legt fest, was nach erfolgreichem Vertragsschluss mit den Daten gemacht werden darf.</p>
        </div>
      </div>

      <div class="policy-choice-grid policy-choice-grid--stacked">
        <button
          type="button"
          class="policy-choice"
          [class.is-active]="contractPolicy.mode === 'view-only'"
          (click)="updateMode('view-only')">
          <strong>View-Only</strong>
          <span>Vorschau im Browser, keine Downloads, kein Export.</span>
        </button>
        <button
          type="button"
          class="policy-choice"
          [class.is-active]="contractPolicy.mode === 'compute-to-data'"
          (click)="updateMode('compute-to-data')">
          <strong>Compute-to-Data</strong>
          <span>Nur algorithmische Auswertung, keine direkte Rohdatennutzung.</span>
        </button>
        <button
          type="button"
          class="policy-choice"
          [class.is-active]="contractPolicy.mode === 'controlled-export'"
          (click)="updateMode('controlled-export')">
          <strong>Kontrollierter Export</strong>
          <span>Export nach Vertragsprüfung, z. B. PDF und XML unter klaren Auflagen.</span>
        </button>
      </div>

      <div class="policy-controls">
        <div class="policy-controls__field" *ngIf="exportAllowed">
          <label>Erlaubte Exportformate</label>
          <div class="policy-export-formats">
            <button
              type="button"
              class="policy-format"
              [class.is-active]="isFormatSelected('PDF')"
              (click)="toggleExportFormat('PDF')">
              PDF
            </button>
            <button
              type="button"
              class="policy-format"
              [class.is-active]="isFormatSelected('XML')"
              (click)="toggleExportFormat('XML')">
              XML
            </button>
          </div>
        </div>
      </div>

      <div class="policy-controls">
        <div class="policy-controls__field policy-controls__field--full">
          <label>Pricing</label>
          <div class="policy-choice-grid">
            <button
              type="button"
              class="policy-choice"
              [class.is-active]="pricing?.type === 'FREE'"
              (click)="updatePricingType('FREE')">
              <strong>Kostenfrei</strong>
              <span>Keine Preisangaben erforderlich.</span>
            </button>
            <button
              type="button"
              class="policy-choice"
              [class.is-active]="pricing?.type === 'PAID'"
              (click)="updatePricingType('PAID')">
              <strong>Kostenpflichtig</strong>
              <span>Zeigt Preis, Währung und Abrechnungsbasis im Offer an.</span>
            </button>
          </div>
        </div>

        <ng-container *ngIf="showPaidFields">
          <div class="policy-controls__field">
            <label for="pricing-amount">Betrag</label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Betrag</mat-label>
              <input
                id="pricing-amount"
                matInput
                type="number"
                min="0.01"
                step="0.01"
                [ngModel]="pricing?.amount"
                (ngModelChange)="updatePricingAmount($event)">
            </mat-form-field>
          </div>

          <div class="policy-controls__field">
            <label for="pricing-currency">Währung</label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Währung</mat-label>
              <mat-select
                id="pricing-currency"
                [ngModel]="pricing?.currency"
                (ngModelChange)="updatePricingCurrency($event)">
                <mat-option *ngFor="let currency of currencyOptions" [value]="currency">
                  {{ currency }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="policy-controls__field policy-controls__field--full">
            <label for="billing-basis">Abrechnung</label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Abrechnungsbasis</mat-label>
              <mat-select
                id="billing-basis"
                [ngModel]="pricing?.billingBasis"
                (ngModelChange)="updateBillingBasis($event)">
                <mat-option *ngFor="let basis of billingBasisOptions" [value]="basis">
                  {{ basis }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
      </div>

      <button
        type="button"
        mat-stroked-button
        class="policy-json-toggle"
        (click)="showJsonView = !showJsonView">
        {{ showJsonView ? 'JSON Richtlinie ausblenden' : 'JSON Richtlinie anzeigen' }}
      </button>

      <pre class="policy-json-view" *ngIf="showJsonView">{{ policyAsJson | json }}</pre>
    </section>
  </div>
</div>
